'use client';
import Breadcrumbs from '@/app/components/Breadcrumbs';
import { LeftNavContainer } from '@/app/components/Layout';

export const AdminPages = {
  USERS: {
    href: '/admin/users',
    labelText: 'Users',
  },
  GBP_ADMIN: {
    href: '/admin/gbp-admin',
    labelText: 'GBP Admin',
  },
  FEATURE_FLAGS: {
    href: '/admin/feature-flags',
    labelText: 'Feature Flags',
  },
  BULK_VIOLATIONS: {
    href: '/admin/bulk-resolve-violations',
    labelText: 'Violations Bulk Actions',
  },
} as const;

export type AdminPage = (typeof AdminPages)[keyof typeof AdminPages];

export const AdminDashboardNav: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="mt-4 bg-gray-50 px-5">
      {/* Breadcrumb Navigation */}
      <Breadcrumbs separator="/" />

      {/* Navigation Sidebar and Page Content */}
      <div className="mt-3 flex w-full gap-3">
        <LeftNavContainer
          groups={[
            {
              title: 'Navigation',
              links: [
                {
                  href: AdminPages.USERS.href,
                  text: AdminPages.USERS.labelText,
                  protectWith: ['SYSTEM:ADMIN'],
                },
                { href: AdminPages.GBP_ADMIN.href, text: AdminPages.GBP_ADMIN.labelText },
                {
                  href: AdminPages.FEATURE_FLAGS.href,
                  text: AdminPages.FEATURE_FLAGS.labelText,
                  protectWith: ['SYSTEM:ADMIN'],
                },
                {
                  href: AdminPages.BULK_VIOLATIONS.href,
                  text: AdminPages.BULK_VIOLATIONS.labelText,
                },
              ],
            },
          ]}
        />
        <div className="w-full">{children}</div>
      </div>
    </div>
  );
};
